import React from 'react';
import { Button, Card, CardContent, cn } from '@mf-tools/domains-ui';
import { ArrowRight } from 'lucide-react';
import { Container } from '../components';
import { scrollToId } from '../lib/scroll';

const OPEN_APP_URL = 'https://app.opspilott.com';

export interface CTAProps {
  className?: string;
}

export function CTA({ className }: CTAProps): React.ReactElement {
  return (
    <section className={cn('py-10 sm:py-14', className)} aria-label="Call to action">
      <Container>
        <Card className="border-primary/25 bg-primary/5">
          <CardContent className="flex flex-col items-start justify-between gap-6 p-6 sm:flex-row sm:items-center sm:p-8">
            <div className="space-y-2">
              <div className="text-xl font-semibold text-foreground sm:text-2xl">
                Fewer tools. Lower cost. Faster execution. Less risk.
              </div>
              <div className="text-sm text-muted-foreground">
                Consolidate operations into one platform built for speed and accountability.
              </div>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
              <Button asChild size="lg" className="w-full sm:w-auto">
                <a href={OPEN_APP_URL} target="_blank" rel="noreferrer">
                  Open App <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </Button>
              <Button
                size="lg"
                variant="secondary"
                className="w-full sm:w-auto"
                onClick={() => scrollToId('contact')}
              >
                Contact
              </Button>
            </div>
          </CardContent>
        </Card>
      </Container>
    </section>
  );
}

